/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LaunchIcon = /*#__PURE__*/ createSvgIcon(
  'LaunchIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.646 9.146c.194-.39.406-.768.635-1.136.23-.368.469-.732.719-1.093L6.854 6.77 5.021 8.604l1.625.542zm9.479-5.625a6.51 6.51 0 00-3.083.854 11.716 11.716 0 00-2.604 2c-.528.528-1 1.09-1.417 1.687-.417.598-.792 1.23-1.125 1.896l2.125 2.125a15.14 15.14 0 001.896-1.125 12.5 12.5 0 001.687-1.416 12.324 12.324 0 002.031-2.688c.563-1 .844-2 .844-3a.277.277 0 00-.031-.125.395.395 0 00-.073-.104.2.2 0 00-.104-.083.46.46 0 00-.146-.021zm-4.688 5.041A1.446 1.446 0 0111 7.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0112.5 6c.417 0 .77.146 1.063.437.291.292.437.646.437 1.063 0 .417-.146.77-.438 1.062A1.447 1.447 0 0112.5 9c-.417 0-.77-.146-1.063-.438zm-.583 4.792l.542 1.625 1.833-1.833L13.083 12c-.36.25-.725.49-1.093.719-.369.229-.747.44-1.136.635zm7.084-10.5a7.327 7.327 0 01-.657 4.125 12.536 12.536 0 01-2.49 3.521l-.176.177c-.049.049-.101.108-.157.177l.25 2.104c.028.236.004.466-.073.688a1.34 1.34 0 01-.364.562L11.5 16.98a.714.714 0 01-.656.198.572.572 0 01-.469-.427l-1.063-3.23L6.5 10.689 3.25 9.582a.552.552 0 01-.417-.468.69.69 0 01.209-.636l2.75-2.77a1.48 1.48 0 011.25-.438l2.104.27c.07-.069.135-.131.198-.187.062-.055.128-.118.198-.187a13.047 13.047 0 013.5-2.48 7.01 7.01 0 014.083-.645.746.746 0 01.302.104c.09.055.17.118.24.187.07.07.128.146.177.23a.76.76 0 01.093.291zm-14.23 10.25c.43-.444.952-.656 1.563-.635a2.28 2.28 0 011.583.698c.43.43.656.944.677 1.541a1.936 1.936 0 01-.614 1.521 4.3 4.3 0 01-2.26 1.26c-.883.188-1.768.358-2.657.511a92.3 92.3 0 01.5-2.636 4.364 4.364 0 011.208-2.26zm.938 1.188a1.803 1.803 0 00-.48.833l-.25.958c.32-.083.633-.166.938-.25.306-.083.577-.243.813-.479a.823.823 0 00.302-.573.683.683 0 00-.198-.573.67.67 0 00-.563-.198.847.847 0 00-.562.282z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LaunchIcon;
